import { Stack, Typography } from '@mui/material';

// Renders a quantity with an explicit unit so raw/post-tumble weights, capacities, and
// durations are never ambiguous side by side (ASSESSMENT.md P2: Product Master table mixed
// units with no labels across 20+ columns).
export default function QuantityWithUnit({ value, unit, precision = 1, emptyText = '—', color }) {
  if (value === null || value === undefined || value === '') {
    return <Typography color="text.secondary">{emptyText}</Typography>;
  }
  const numeric = Number(value);
  const display = Number.isFinite(numeric) ? numeric.toFixed(precision) : String(value);
  return (
    <Stack direction="row" spacing={0.5} alignItems="baseline">
      <Typography color={color}>{display}</Typography>
      <Typography variant="caption" color="text.secondary">{unit}</Typography>
    </Stack>
  );
}
